{
  "info": "Teave",
  "negative": "Viga",
  "positive": "Valmis"
}
